import config from '@/config';

/**
 * A dynamic import of a content-hashed chunk failed.
 *
 * After a deploy the backend replaces `frontend/build`, so an open tab's next
 * navigation asks for a file that is gone (JSON 404). Chrome, Firefox, and
 * Safari each phrase that failure differently. A plain "Failed to fetch" is an
 * API call and must not match.
 */
const STALE_CHUNK_MESSAGES = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  'Unable to preload CSS',
];

export function isStaleChunkLoadError(error: unknown): boolean {
  if (typeof error !== 'object' || error === null) {
    return false;
  }

  if ('name' in error && error.name === 'ChunkLoadError') {
    return true;
  }

  const message = 'message' in error ? error.message : undefined;
  if (typeof message !== 'string') {
    return false;
  }

  return STALE_CHUNK_MESSAGES.some((pattern) => message.includes(pattern));
}

/** Dev keeps the real error on screen. Production treats a missing chunk as a stale tab. */
export function isQuietStaleChunk(error: unknown): boolean {
  return !config.isDev && isStaleChunkLoadError(error);
}
